<template>
  <div>
    <h1>Resources</h1>
    <div class="row hidden-md-down" id="qm-itemlist-header">
      <div class="col-6 col-sm-6 col-md-2">Day</div>
      <div class="col-6 col-sm-6 col-md-2">Time</div>
      <div class="col-6 col-sm-8 col-md-3">Vehicle Type</div>
      <div class="col-6 col-sm-4 col-md-1">Trailer</div>
      <div class="col-4 col-md-1">Packer</div>
      <div class="col-4 col-md-1">Fitter</div>
      <div class="col-4 col-md-1">Porter</div>
      <div class="col-12 col-md-1"></div>
    </div>
    <ul v-if="resources.length >  0" class="list-group" id="qm-item-list">
      <resource v-for="resource in resources" v-bind:resource="resource" v-bind:key="resource.resourceId"></resource>
    </ul>
    <p v-else class="qm-empty-message">
      <i class="fa fa-exclamation-triangle"></i>
      No resources available yet
    </p>
    <p>
      <button v-on:click="addNewResource" type="button" class="btn btn-turquois">
        <i class="fa fa-fw fa-plus"></i>
        Add Resource
      </button>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import Resource from './children/Resource.vue'
export default {
  name: 'ResourceList',
  components: {
    'resource': Resource
  },
  data: () => ({
    dataAvailable: false
  }),
  computed: {
    ...mapGetters({
      session: 'getSession',
      resources: 'getAllResources'
    })
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('loadResources', this.session.surveyId).then(() => {
        this.dataAvailable = true
      })
    })
  },
  methods: {
    addNewResource () {
      var emptyResource = {
        resourceId: this.session.nextResourceId,
        surveyId: this.session.surveyId,
        date: null,
        time: null,
        vehicleTypeId: null,
        trailer: null,
        packer: 0,
        fitter: 0,
        porter: 0
      }
      this.$store.dispatch('addResource', {
        storageKey: 'survey-' + this.session.surveyId + '-resource-' + this.session.nextResourceId,
        resource: emptyResource
      })
      this.$store.dispatch('incrementNextResourceId').then(() => {
        $('html, body').animate({ scrollTop: $(document).height() }, 'slow')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResourceList.vue